/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VirtualHealthLibraryStrictHttpResponse } from '../../virtual-health-library-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MediaMediaItemUrlGet$Params {
  mediaId?: string;
}

export function mediaMediaItemUrlGet(http: HttpClient, rootUrl: string, params?: MediaMediaItemUrlGet$Params, context?: HttpContext): Observable<VirtualHealthLibraryStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, mediaMediaItemUrlGet.PATH, 'get');
  if (params) {
    rb.query('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VirtualHealthLibraryStrictHttpResponse<string>;
    })
  );
}

mediaMediaItemUrlGet.PATH = '/Media/MediaItemUrl';
